import { isMeticulousContext } from '@src/app/utils/meticulous/meticulousUtils';
import { appLocale } from '@src/config/locale';
import Betler from '@src/config/playerAccountManagement/Betler';
import Comtrade from '@src/config/playerAccountManagement/Comtrade';
import { StaticConfig } from '@src/config/staticTypes';

const loadRequired = (name: string): string => {
    const v = process.env[name];
    if (!v) {
        throw new Error(`Missing required '${name}' environment variable`);
    }
    return v;
};

const env = loadRequired('NODE_ENV');
window.superbetVersion = process.env.APP_VERSION;

export const commonConfig: Omit<StaticConfig, 'countrySpecific'> = {
    appLocale,
    services: {
        playerAccountManagement: process.env.PLAYER === 'Comtrade' ? Comtrade : Betler,
        paymentProvidersUrl: 'ignore it here',
    },

    app: {
        user: {
            history: {
                pageSize: 5,
            },
            idCardVerification: {
                allowedFormats: [
                    'image/jpeg',
                    'image/png',
                    'application/pdf',
                ],
                pendingHours: 72,
            },
        },

        sportOffer: {
            gridDateFutureThreshold: 6,
        },
    },

    environment: {
        isProdEnvironment: false,
        name: env,
        isProduction: env === 'production',
        isDevelopment: env === 'development' || isMeticulousContext(),
        isTest: env === 'test',
        version: process.env.APP_VERSION || '',
    },
};
